<template>
    <dashboard-layout title="개인정보 및 이력서 관리" topBtn>
        <template slot="topBtn">
            <v-fade-transition hide-on-leave>
                <v-btn v-show="mode == 'view'" v-bind="{ loading }" color="secondary" @click="mode = 'form'"> 수정하기 </v-btn>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
                <v-btn v-show="mode == 'form'" v-bind="{ loading }" color="primary" @click="mode = 'view'"> 취소하기 </v-btn>
            </v-fade-transition>
        </template>
        <template slot="contents">
            <resume-personal-information v-model="form" v-bind="{ mode }" />
            <resume-name v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode }" />
            <resume-education v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode }" />
            <resume-work-experience v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode }" />
            <resume-hash-tags v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode, hashTags }" />
            <resume-languages v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode }" />
            <resume-office-skills v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode }" />
            <resume-certifications v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode }" />
            <resume-cover-letter v-model="form" class="mt-40 mt-lg-60" v-bind="{ mode }" />
            <v-slide-y-reverse-transition>
                <div v-show="mode == 'form'">
                    <v-card-actions>
                        <div class="v-btn-group">
                            <!-- <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="reset">
                                <span class="grey-6--text">초기화</span>
                            </v-btn> -->
                            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="save">
                                <span>저장하기</span>
                            </v-btn>
                        </div>
                        <!-- <v-btn class="my-n10" color="primary" outlined v-bind="{ loading }" @click="reset"> 초기화 </v-btn>
                        <v-spacer />
                        <v-btn class="my-n10" color="primary" v-bind="{ loading }" @click="save"> 저장하기 </v-btn> -->
                    </v-card-actions>
                </div>
            </v-slide-y-reverse-transition>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { USER_FILE_TYPES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import ResumeName from "@/components/client/resume/resume-name.vue";
import ResumeHashTags from "@/components/client/resume/resume-hash-tags.vue";
import ResumeEducation from "@/components/client/resume/resume-education.vue";
import ResumeLanguages from "@/components/client/resume/resume-languages.vue";
import ResumeCoverLetter from "@/components/client/resume/resume-cover-letter.vue";
import ResumeOfficeSkills from "@/components/client/resume/resume-office-skills.vue";
import ResumeCertifications from "@/components/client/resume/resume-certifications.vue";
import ResumeWorkExperience from "@/components/client/resume/resume-work-experience.vue";
import ResumePersonalInformation from "@/components/client/resume/resume-personal-information.vue";
import { mapActions } from "vuex";

export default {
    components: {
        DashboardLayout,
        ResumeName,
        ResumeHashTags,
        ResumeEducation,
        ResumeLanguages,
        ResumeCoverLetter,
        ResumeOfficeSkills,
        ResumeCertifications,
        ResumeWorkExperience,
        ResumePersonalInformation,
    },
    data: () => ({
        form: undefined,
        resume: undefined,
        hashTags: [],

        mode: "view",
        loading: false,
    }),
    computed: {
        profileSrc() {
            if (this.resume?.profile?.url) return this.resume.profile.url;
            if (this.resume?.profile instanceof File) return URL.createObjectURL(this.resume.profile);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        mode(mode) {
            if (mode == "view") this.reset();
        },
    },
    methods: {
        ...mapActions(["getUser"]),
        init() {
            this.loading = false;
            this.resume = undefined;
            this.search();
        },
        reset() {
            this.form = JSON.parse(JSON.stringify(this.resume));
        },
        async search() {
            this.loading = true;
            try {
                const { resume } = await api.v1.person.resume.get();
                this.resume = this.formResume(resume);

                this.hashTags = (await api.v1.setting.get())?.setting?.hashTags || [];
            } finally {
                this.reset();
                this.loading = false;
            }
        },
        validate() {
            /** @type {import("@/plugins/vue-validate").Criterion[]} */
            let criteria = [
                {
                    key: "personalInformation.name",
                    message: "이름을 입력하세요",
                },
                {
                    key: "personalInformation.bornAt",
                    message: "생년월일을 입력하세요",
                },
                {
                    key: "personalInformation.gender",
                    message: "성별을 입력하세요",
                },
                {
                    key: "personalInformation.phone",
                    message: "연락처를 입력하세요",
                },
                {
                    key: "personalInformation.email",
                    message: "이메일을 입력하세요",
                },
                {
                    key: "personalInformation.residence.postcode",
                    message: "우편번호를 입력하세요",
                },
                {
                    key: "personalInformation.residence.address1",
                    message: "기본주소를 입력하세요",
                },
                {
                    key: "personalInformation.residence.address2",
                    message: "상세주소를 입력하세요",
                },
                {
                    key: "name",
                    message: "이력서 제목을 입력하세요",
                },
            ];
            return this.$validate(this.form, criteria);
        },
        async save() {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                let { profile, ...form } = this.form || {};
                if (profile instanceof File) {
                    profile = (await api.v1.me.files.post({ type: USER_FILE_TYPES.PROFILE.value }, profile))?.file;
                }
                form._profile = profile?._id ?? null;
                const { resume } = await api.v1.person.resume.put(form);
                this.resume = this.formResume(resume);
                this.getUser();
            } finally {
                this.loading = false;
                this.mode = "view";
            }
        },
        formResume(resume) {
            if (resume?.personalInformation?.bornAt) resume.personalInformation.bornAt = resume.personalInformation.bornAt.toDate();
            for (const item of resume?.education?.otherEducations || []) {
                item.tempId = Math.random();
            }
            for (const item of resume?.workExperience?.list || []) {
                item.tempId = Math.random();
                if (item?.duration?.startsAt) item.duration.startsAt = item.duration.startsAt.toDate();
                if (item?.duration?.endsAt) item.duration.endsAt = item.duration.endsAt.toDate();
            }
            return resume;
        },
    },
};
</script>
